import * as React from 'react';
import Popup from 'reactjs-popup';
import { IText } from '../tron-editor-api';
import Select from 'react-select';
import { localization } from '../../../shared/localization/localization';
import { ISelectorOption } from '../../../shared/common-dtos';
import { ValueType } from 'react-select/lib/types';
import { BoldIcon } from '../../../shared/icons/pt-icon-bold';
import { AlignCenterIcon } from '../../../shared/icons/pt-icon-align-center';
import { ItalicIcon } from '../../../shared/icons/pt-icon-italic';
import { AlignLeftIcon } from '../../../shared/icons/pt-icon-align-left';
import { AlignRightIcon } from '../../../shared/icons/pt-icon-align-right';
import { FillPicker } from './fill-picker.component';
import { AlignOptions } from './logo-editor-object-settings.component';
import { DebuggerInstance } from 'src/App/shared/debugger';

const FontOptions: ISelectorOption[] = [
    { value: 'Arial', label: 'Arial' },
    { value: 'Trebuchet MS', label: 'Trebuchet MS' },
    { value: 'Times New Roman', label: 'Times New Roman' },
    { value: 'Comic sans MS', label: 'Comic sans MS' },
    { value: 'Courier', label: 'Courier' },
    { value: 'Garamond', label: 'Garamond' },
    { value: 'Impact', label: 'Impact' },
];

interface IOptionStyleData {
    data: ISelectorOption;
    isDisabled: boolean;
    isFocused: boolean;
    isSelected: boolean;
}

interface IValueStyleData {
    data: ISelectorOption;
}

const fontStyles: any = {
    control: (styles: any) => ({ ...styles, backgroundColor: 'white' }),
    option: (styles: any, styleData: IOptionStyleData) => {
        return {
            ...styles,
            fontFamily: styleData.data.value
        };
    },
    singleValue: (styles: any, styleData: IValueStyleData) => {
        return {
            ...styles,
            fontFamily: styleData.data.value
        };
    },
};

export interface ILogoEditorTextSettingsProps {
    textObject: IText;
    recentColors: string[];
    logoColors: string[];
    onTextChange(text: string): void;
    onFontChange(font: string): void;

    onTextAlignLeft(): void;
    onTextAlignRight(): void;
    onTextAlignCenter(): void;

    onBoldToggle(): void;
    onItalicToggle(): void;

    onSetColor(type: string, color: string): void;
    addPresetColor: (color: string) => void;
}

interface IState {
    text: string;
    font: string;
}

export class LogoEditorTextSettings extends React.Component<ILogoEditorTextSettingsProps, IState> {

    private textInput: HTMLInputElement | null;

    constructor(props: ILogoEditorTextSettingsProps) {
        super(props);
        DebuggerInstance.log('LogoEditorTextSettings');
        DebuggerInstance.log(props);

        this.state = {
            text: '',
            font: ''
        };

        this.init = this.init.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
    }

    public componentDidMount() {
        this.init(this.props);
    }

    public componentWillReceiveProps(nextProps: ILogoEditorTextSettingsProps) {
        if (nextProps.textObject) {
            this.init(nextProps);
        }
    }

    private init(props: ILogoEditorTextSettingsProps) {
        this.setState({
            text: props.textObject.Text,
            font: props.textObject.FontFamily
        });
    }

    private handleTextChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ text: event.target.value });
        this.props.onTextChange(event.target.value);
    }

    private getAlignIcon(): JSX.Element {
        if (this.props.textObject) {
            switch (this.props.textObject.Align) {
                case AlignOptions.left:
                    return <AlignLeftIcon />;
                case AlignOptions.center:
                    return <AlignCenterIcon />;
                case AlignOptions.right:
                    return <AlignRightIcon />;
            }
        }

        return <div></div>;
    }

    private handleFontChanged(selected: ValueType<ISelectorOption>): void {
        DebuggerInstance.log('handleFontChanged');
        DebuggerInstance.log(selected);

        const selectedOption = selected as ISelectorOption;

        if (selectedOption) {
            this.setState({ font: selectedOption.value });
            this.props.onFontChange(selectedOption.value);
        }
    }

    // private handleInputKeyDown(e: React.KeyboardEvent<HTMLInputElement>): void {
    //     // handling space-key because change event is blocked by tron-editor
    //     if (e.keyCode && e.keyCode === 32 && this.textInput) {
    //         this.insertAtCaret(this.textInput, " ")
    //     }
    // }

    // private insertAtCaret(element: HTMLInputElement, text: string) {
    //     if ((document as any).selection) {
    //         element.focus();
    //         const sel = (document as any).selection.createRange();
    //         sel.text = text;
    //         element.focus();
    //     } else if (element.selectionStart || element.selectionStart === 0) {
    //         const startPos = element.selectionStart;
    //         const endPos = (element as any).selectionEnd;
    //         const scrollTop = element.scrollTop;
    //         element.value = element.value.substring(0, startPos) + text + element.value.substring(endPos, element.value.length);
    //         element.focus();
    //         element.selectionStart = startPos + text.length;
    //         element.selectionEnd = startPos + text.length;
    //         element.scrollTop = scrollTop;
    //     } else {
    //         element.value += text;
    //         element.focus();
    //     }
    // }

    public render() {
        return (
            <div className="text-properties-root">
                <input id="troneditor-text-input" className="promotron-troneditor-allow-writing text-prop-input" type="text"
                    ref={(ref) => this.textInput = ref}
                    value={this.state.text}
                    onChange={(e) => this.handleTextChange(e)}
                    // onKeyDown={(e) => this.handleInputKeyDown(e)}
                    placeholder={localization.editorLoc.logoEditorContent.textDefault + '...'}
                    data-tip={localization.editorLoc.logoEditorContent.toolTips.textValue} />
                <div data-tip={localization.editorLoc.logoEditorContent.toolTips.textFont}>
                    <Select options={FontOptions}
                        className="text-prop-font"
                        classNamePrefix="text-prop-font-option"
                        value={FontOptions.find(o => o.value === this.state.font)}
                        onChange={(e: ValueType<ISelectorOption>) => this.handleFontChanged(e)}
                        menuPlacement="top"
                        styles={fontStyles}
                    />
                </div>
                <div className="text-prop-font-size"
                    data-tip={localization.editorLoc.logoEditorContent.toolTips.textFontSize}>
                    <div className="text-prop-font-size-value">
                        {Math.trunc(this.props.textObject.FontSize || 0)}
                    </div>
                    <div className="text-prop-font-size-label">pt</div>
                </div>
                <Popup
                    trigger={open => (
                        <button className="shape-control-btn" data-tip={localization.editorLoc.logoEditorContent.toolTips.textAlign}>
                            {this.getAlignIcon()}
                        </button>
                    )}
                    contentStyle={{ width: 'auto', padding: '5px', border: 'none' }}
                    position="top center"
                    closeOnDocumentClick={true}
                >
                    <div id="setting-text-align-style" className="logo-text-font-options-container">
                        <button className="align-control-btn"
                            data-tip="align left"
                            onClick={() => {
                                this.props.onTextAlignLeft();
                            }}>
                            <AlignLeftIcon />
                        </button>
                        <button className="align-control-btn"
                            data-tip="align center"
                            onClick={() => {
                                this.props.onTextAlignCenter();
                            }}>
                            <AlignCenterIcon />
                        </button>
                        <button className="align-control-btn"
                            data-tip="align right"
                            onClick={() => {
                                this.props.onTextAlignRight();
                            }}>
                            <AlignRightIcon />
                        </button>
                    </div>
                </Popup>
                <button
                    className={'shape-toggle-btn' + (this.props.textObject.Bold ? ' shape-toggle-btn-toggled' : '')}
                    onClick={() => this.props.onBoldToggle()}
                    data-tip={localization.editorLoc.logoEditorContent.toolTips.textToggleBold}
                >
                    <BoldIcon />
                </button>
                <button
                    className={'shape-toggle-btn' + (this.props.textObject.Italic ? ' shape-toggle-btn-toggled' : '')}
                    onClick={() => this.props.onItalicToggle()}
                    data-tip={localization.editorLoc.logoEditorContent.toolTips.textToggleItalic}
                >
                    <ItalicIcon />
                </button>
                <FillPicker
                    selectedColor={this.props.textObject.FillColor}
                    recentColors={this.props.recentColors}
                    logoColors={this.props.logoColors}
                    hint={localization.editorLoc.logoEditorContent.toolTips.textColor}
                    onColorChanged={(color) => this.props.onSetColor("fill", color)}
                    addPresetColor={this.props.addPresetColor}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/logo-app/logo-editor/logo-editor-controls/logo-editor-text-settings.component.tsx